import React from 'react';

const WarningTriangleIcon = ({ width = 20, height = 18, color = '#FF0000', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M19.7807 15.4688C20.4054 16.5938 19.6245 18 18.336 18H1.66397C0.3755 18 -0.405392 16.5938 0.219322 15.4688L8.53583 0.84375C9.19958 -0.28125 10.8004 -0.28125 11.4251 0.84375L19.7807 15.4688ZM9.08245 5.46429V10.6071C9.08245 11.1696 9.4729 11.5714 10.0195 11.5714C10.5271 11.5714 10.9566 11.1696 10.9566 10.6071V5.46429C10.9566 4.94196 10.5271 4.5 10.0195 4.5C9.4729 4.5 9.08245 4.94196 9.08245 5.46429ZM10.0195 15.4286C10.6833 15.4286 11.2299 14.8661 11.2299 14.183C11.2299 13.5 10.6833 12.9375 10.0195 12.9375C9.31672 12.9375 8.77009 13.5 8.77009 14.183C8.77009 14.8661 9.31672 15.4286 10.0195 15.4286Z"
      fill={color}
    />
  </svg>
);

export default WarningTriangleIcon;
